import { TsrctNegotiationCaseListItem } from '@/generated/gql/graphql';

export enum NegotiationCaseDataGridField {
  SEQUENCE_NUMBER = 'sequenceNumber',
  TOTAL_VALUE = 'totalValue',
  TOTAL_DISCOUNTED_VALUE = 'totalDiscountedValue',
  DISCOUNT = 'discount',
  TOTAL_PRICE_DISCOUNT = 'totalPriceDiscount',
  REFERENCE_ID = 'referenceId',
  NEGOTIATION_BOUNDARY_UPPER = 'negotiationBoundaryUpper',
  NEGOTIATION_BOUNDARY_LOWER = 'negotiationBoundaryLower',
  ORGANIZATION_ID = 'organizationId',
  SUPPLIER_NAME = 'supplierName',
  SUPPLIER_LOCATION = 'supplierLocation',
  SUPPLIER_EXTERNAL_REFERENCE = 'supplierExternalReference',
  SUPPLIER_CONTACT_FIRST_NAME = 'supplierContactFirstName',
  SUPPLIER_CONTACT_LAST_NAME = 'supplierContactLastName',
  SUPPLIER_CONTACT_EMAIL = 'supplierContactEmail',
  SUPPLIER_CONTACT_PHONE = 'supplierContactPhone',
  ISSUES_OPEN_COUNT = 'issuesOpenCount',
  ISSUES_COMPLETED_COUNT = 'issuesCompletedCount',
  ISSUES_TOTAL_COUNT = 'issuesTotalCount',
  UPDATED_AT = 'updatedAt',
  CREATED_AT = 'createdAt',
  STATUS = 'status',
  PROCESS_STATUS = 'processStatus',
  RESPONSIBLE_IDS = 'responsibleIds',
  HAS_SUPPLIER_COMMENT = 'hasSupplierComment',
  DEMAND_SEQUENCE_NUMBER = 'demandSequenceNumber',
  LATEST_COMMENT = 'latestComment',
}

export enum NegotiationCaseDataGridColumnGroup {
  SUPPLIER = 'supplier',
  NEGOTIATION = 'negotiation',
  ISSUES = 'issues',
}

export type NegotiationCaseDataGridRow = TsrctNegotiationCaseListItem;
